var map = {
	"./add.png": 1562,
	"./alarm.png": 940,
	"./alarmset.png": 6154,
	"./category.png": 9379,
	"./chart.png": 9635,
	"./collapse.png": 7734,
	"./contentBg.png": 2889,
	"./datareport.png": 9293,
	"./delete.png": 3866,
	"./download.png": 5651,
	"./druid.png": 9731,
	"./home.png": 78,
	"./jkrb.png": 1182,
	"./logo.png": 425,
	"./logodz.png": 4056,
	"./no-video.png": 1076,
	"./open.png": 6619,
	"./spjhgl.png": 4765,
	"./ssjkkb.png": 723,
	"./start.png": 5375,
	"./system.png": 8096,
	"./table.png": 5727,
	"./zdykb.png": 8259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4504;